module.exports = __webpack_public_path__ + "img/101.80a462be.svg";